import { useRef, useState, useEffect } from "react";
import useAxios from "../../utils/useAxios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import GiftTab from "./GiftTab.js";
import DonationTab from "./DonationTab.js";
import RecurringDonationTab from "./RecurringDonationTab.js";
import ManualRecurringDonationTab from "./ManualRecurringDonationTab.js";
import { currentDateAndTime } from "../../utils/generateCurrentDateAndTime.js";
import { showModal, hideModal } from "../../utils/modalUtility.js";
import DonorCard from "./DonorCard.js";
import { useAppContext } from "../../context/AppContext.js";
import Select from "react-select";
import { fieldsList } from "../../data/data.js";
import FollowUpRemarkTab from "./FollowUpRemarkTab.js";
import OtherAccount from "./OtherAccount.js";
import { useLocation, useNavigate } from "react-router-dom";
import { useAgencies } from "../../hooks/useAgencies.js";

const INITIAL_FILTERS = {
  level: [],
  search: "",
  agency: "",
  status: "",
  payment_mode: "",
};

const USER_DETAILS_INITIAL_STATE = {
  fullName: "", // Mandate Owner
  // contact_id: "",
  schemePatronshipNo: "", // Scheme Patronship No.
  phoneNumber: "", // Mandate Name
  address: "",
  is_address_confirmed: "",
  bankName: "",
  mailingCity: "",
  mailingCountry: "",
  mailingState: "",
  dateOfBirth: "",
  mailingZip: "",
  occupation: "",
  gender: "",
  whatsappNumber: "",
  whatsappUpdate: "",
  // bankAccountName: "",
  phone: "",
  startDate: "",
  email: "",
  frequency: "",
  amount: "",
  donationType: "",
  mode: "",
  whatsappGroupNo: "",
  patronshipLevel: "",
  remarks: "",
  status: "",
  statusDetails: "",
  panNo: "",
  stopHoldDate: "",
  enrolledByContact: "",
  depositoryBank: "",
  want80G: "", // Y / N
  leadSource: "",
  enrolledByName: "",
  preacherName: "",
  trNumber: "",
  totalDonation: "",
  accountHolderName: "",
  bankIFSC: "",
  bankBranch: "",
  bankAccountNo: "",
  processingAgency: "",
  manualType: "",
  micrNo: "",
  deductionDay: "",
  utilityCode: "",
  isVolunteer: "",
};

const MODE_OPTIONS = [
  "Manual",
  "One Time Donation",
  "CASH",
  "UPI",
  "Online",
  "Cheque",
];

function Donor() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [currentPhoneNumber, setCurrentPhoneNumber] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [role, setRole] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [receiptDetails, setReceiptDetails] = useState({});
  const [userDetails, setUserDetails] = useState([]);
  const [view, setView] = useState("excel"); // default: show Excel section
  const [bulkView, setBulkView] = useState("bulk"); // default: show Excel section
  const [excelFile, setExcelFile] = useState(null);
  const [notFoundMessage, setNotFoundMessage] = useState("");
  const [message, setMessage] = useState("");
  const [downloading, setDownloading] = useState(false);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [uploadRows, setUploadRows] = useState([]);
  const [activeTab, setActiveTab] = useState("User Details");
  const [messageMode, setMessageMode] = useState("");

  const [otpLoader, setOtpLoader] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const { state } = useAppContext();

  const [selectedFields, setSelectedFields] = useState(fieldsList);

  const fileInputRef = useRef();
  const bulkFileInputRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();

  const [filters, setFilters] = useState(INITIAL_FILTERS);

  const { agencies, loading: agenciesLoading } = useAgencies();

  // if (loading) return <p>Loading...</p>;

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedFields(fieldsList); // select all
    } else {
      setSelectedFields([]); // unselect all
    }
  };

  const handleCheckboxChange = (field) => {
    setSelectedFields((prev) =>
      prev.includes(field)
        ? prev.filter((item) => item !== field)
        : [...prev, field],
    );
  };

  // console.log("Selected fields",selectedFields)

  // Handler to update filters
  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSearchClick = () => {
    setPage(1); // Reset page
    fetchDonors(filters, 1); // API call manually
  };

  const handleExcelFileChange = (e) => {
    const file = e.target.files[0];
    if (
      file &&
      file.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      alert("Please upload a valid Excel file (.xlsx)");
      setExcelFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = null; // Reset input field
      }
    } else {
      setExcelFile(file);
    }
  };

  /**
   *
   * Handle Bulk Uploade
   */
  const handleBulkExcelFileChange = (e) => {
    const file = e.target.files[0];
    if (
      file &&
      file.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      alert("Please upload a valid Excel file (.xlsx)");
      setExcelFile(null);
      if (bulkFileInputRef.current) {
        bulkFileInputRef.current.value = null; // Reset input field
      }
    } else {
      setExcelFile(file);
    }
  };

  const handleExcelSubmit = async (e) => {
    e.preventDefault();

    if (!excelFile) {
      alert("Please select an Excel file.");
      return;
    }

    const formData = new FormData();
    formData.append("excel", excelFile);

    try {
      const response = await axiosAPI.post(
        "/api/donor/upload-excel",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      //Store the rows for displaying summary table

      const {
        message = "",
        insertedCount = 0,
        rows = [],
        failedExcelBase64,
      } = response.data;

      // ⬇ Add this next
      if (failedExcelBase64) {
        const binaryString = atob(failedExcelBase64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "failed_rows.xlsx"; // You can change this filename if needed
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      setUploadRows(rows);

      const failedRows = rows.filter((r) => r.status === "fail");
      const passedRows = rows.filter((r) => r.status === "pass");

      console.log("Upload Summary:", {
        insertedCount,
        passed: passedRows.length,
        failed: failedRows.length,
      });

      //  Fix: Check if rows were even processed
      if (rows.length === 0) {
        window.notifyMessage(
          "Error",
          "No valid data found in Excel file.",
          "error",
        );
      } else if (insertedCount === 0 && failedRows.length > 0) {
        window.notifyMessage(
          "Upload Failed",
          `No rows were inserted.\nFailed Rows: ${failedRows.length}`,
          "error",
        );
        console.table(failedRows);
      } else if (failedRows.length > 0) {
        window.notifyMessage(
          "Partial Success",
          `${message}\nInserted: ${insertedCount}, Failed: ${failedRows.length}`,
          "warning",
        );
        // console.table(failedRows);
      } else {
        window.notifyMessage(
          "Success",
          "Excel file uploaded successfully!",
          "success",
        );
      }

      // closeModal();
      // hideModal("newGiftExcelModal");
      fetchDonors();

      if (fileInputRef.current) fileInputRef.current.value = null;

      setExcelFile(null);
      setMessage("");
    } catch (err) {
      console.log("Erorr", err);
      console.error("Excel Upload Error:", err.message);

      setUploadRows(err?.response?.data?.rows);
      // const errorMsg =
      //   err?.response?.data?.message ||
      //   "Something went wrong while uploading the Excel file.";
      const errorMsg =
        err?.response?.data?.rows[0]?.reason ||
        "Something went wrong while uploading the Excel file.";

      window.notifyMessage("Error", errorMsg, "error");

      if (err.response?.data?.error) {
        console.error("Backend Error:", err.response.data.error);
      }
    }
  };

  /**
   * For
   * Bulk Submit
   */
  const handleBulkExcelSubmit = async (e) => {
    e.preventDefault();

    if (!excelFile) {
      alert("Please select an Excel file.");
      return;
    }

    const formData = new FormData();
    formData.append("excel", excelFile);
    formData.append("upload_date_and_time", currentDateAndTime());

    try {
      const response = await axiosAPI.post(
        "/api/donor/upload-bulk-excel",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      //Store the rows for displaying summary table

      const {
        message = "",
        insertedCount = 0,
        rows = [],
        failedExcelBase64,
      } = response.data;

      // console.log("Data is ",failedExcelBase64)

      // setUploadRows(rows); //   THIS LINE

      // ⬇ Add this next
      if (failedExcelBase64) {
        const binaryString = atob(failedExcelBase64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "failed_rows.xlsx"; // You can change this filename if needed
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      setUploadRows(rows);
      const failedRows = rows.filter((r) => r.status === "fail");
      const passedRows = rows.filter((r) => r.status === "pass");

      console.log("Upload Summary:", {
        insertedCount,
        passed: passedRows.length,
        failed: failedRows.length,
      });

      //  Fix: Check if rows were even processed
      if (rows.length === 0) {
        window.notifyMessage(
          "Error",
          "No valid data found in Excel file.",
          "error",
        );
      } else if (insertedCount === 0 && failedRows.length > 0) {
        window.notifyMessage(
          "Upload Failed",
          `No rows were inserted.\nFailed Rows: ${failedRows.length}`,
          "error",
        );
        console.table(failedRows);
      } else if (failedRows.length > 0) {
        window.notifyMessage(
          "Partial Success",
          `${message}\nInserted: ${insertedCount}, Failed: ${failedRows.length}`,
          "warning",
        );
        console.table(failedRows);
      } else {
        window.notifyMessage(
          "Success",
          "Excel file uploaded successfully!",
          "success",
        );
      }

      // closeModal();
      // hideModal("newGiftExcelModal");
      fetchDonors();
      // console.log("Current red if ",bulkFileInputRef.current)
      if (bulkFileInputRef.current) bulkFileInputRef.current.value = null;

      setExcelFile(null);
      setMessage("");
    } catch (err) {
      console.error("Excel Upload Error:", err);
      setUploadRows(err?.response?.data?.rows);
      const errorMsg =
        err?.response?.data?.message ||
        "Something went wrong while uploading the Excel file.";

      window.notifyMessage("Error", errorMsg, "error");

      if (err.response?.data?.error) {
        console.error("Backend Error:", err.response.data.error);
      }
    }
  };

  const handleBulkUpdateModal = () => {
    showModal("newBulkModal");
  };

  const handleResetFilters = () => {
    setFilters(INITIAL_FILTERS);
    setPage(1);
    setShouldFetch(true);
  };

  useEffect(() => {
    if (shouldFetch) {
      fetchDonors();
      setShouldFetch(false); // reset trigger
    }
  }, [shouldFetch]);

  const [userDetailsFormData, setUserDetailsFormData] = useState(
    USER_DETAILS_INITIAL_STATE,
  );

  const removeFormData = () => {
    setUserDetailsFormData(USER_DETAILS_INITIAL_STATE);
  };

  const axiosAPI = useAxios(); // Use the custom hook for Axios

  const handlePageClick = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setPage(pageNum);
    }
  };

  const buildQuery = (filterObj, currentPage) => {
    const params = new URLSearchParams();
    // console.log("Params", params);

    Object.entries(filterObj).forEach(([key, value]) => {
      // if (value) {
      //   params.append(key, value);
      // }
      if (Array.isArray(value)) {
        value.forEach((v) => params.append(key, v)); // multiple entries for same key
      } else if (value) {
        params.append(key, value);
      }
    });

    params.append("page", currentPage);
    params.append("attributes", selectedFields);
    return params.toString();
  };

  const fetchDonors = async (customFilters = filters, customPage = page) => {
    setLoading(true);
    setNotFoundMessage(""); // reset error

    try {
      const queryString = buildQuery(customFilters, customPage);
      // console.log("Query string", queryString);

      // console.log("Query String",queryString)
      const response = await axiosAPI.get(
        `/api/donor/get-donor?${queryString}`,
      );

      if (response.data?.results?.length > 0) {
        setUsers(response.data.results);
        setTotalPages(response.data.totalPages);
      } else {
        setUsers([]); // clear previous data
        setNotFoundMessage("No donors found.");
      }
    } catch (err) {
      // console.error("Error fetching donors:", err);

      setUsers([]); // clear previous data

      if (err.response?.status === 404) {
        setNotFoundMessage("No donors found.");
      } else {
        setNotFoundMessage("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  // console.log("not found", notFoundMessage);

  useEffect(() => {
    fetchDonors();
  }, [page]);

  // useEffect(() => {
  //   if (location.state?.openModal && location.state?.donorId) {
  //     openUserDetailsModal(location.state.donorId);

  //     if (location.state.activeTab) {
  //       setActiveTab(location.state.activeTab);
  //     }

  //     // IMPORTANT: state clear kar do
  //     navigate(location.pathname, { replace: true });
  //   }
  // }, [location.state]);

  useEffect(() => {
    if (location.state?.openModal && location.state?.donorId) {
      if (location.state.activeTab) {
        setActiveTab(location.state.activeTab);
      }

      openUserDetailsModal(location.state.donorId);

      // router state clear
      navigate(location.pathname, { replace: true });
    }
  }, []);

  useEffect(() => {
    // const role = JSON.parse(localStorage.getItem("user_role")); // Parses string "admin" to plain string
    const role = state?.user?.role; // Parses string "admin" to plain string

    setRole(role);
  }, []);

  useEffect(() => {
    if (view === "manual") {
      showModal("editModal");
    }
  }, [view]);

  const receiptRef = useRef();

  // Handle User Details Input Changes
  // const handleUserDetailsChange = (e) => {
  //   const { id, value } = e.target;
  //   setUserDetailsFormData((prev) => ({
  //     ...prev,
  //     [id]: value,
  //   }));
  // };

  // const handleUserDetailsChange = (e) => {
  //   const { id, value } = e.target;

  //   const modeOptions = [
  //     "Manual",
  //     "One Time Donation",
  //     "CASH",
  //     "UPI",
  //     "Online",
  //     "Cheque",
  //   ];

  //   setUserDetailsFormData((prev) => {
  //     // If mode is changed AND value is one of the allowed options → reset processingAgency
  //     if (id === "mode" && modeOptions.includes(value)) {
  //       return {
  //         ...prev,
  //         [id]: value,
  //         processingAgency: "", // reset here
  //       };
  //     }
  //     else if(id=== "processingAgency" && modeOptions.includes(value))
  //     {
  //          return {
  //         ...prev,
  //         [id]: "",
  //       };
  //     }

  //     // Default update
  //     return {
  //       ...prev,
  //       [id]: value,
  //     };
  //   });
  // };

  const handleUserDetailsChange = (e) => {
    const { id, value } = e.target;

    setUserDetailsFormData((prev) => {
      let updated = {
        ...prev,
        [id]: value,
      };

      // Condition 1: If mode is selected from modeOptions → reset processingAgency
      if (id === "mode" && MODE_OPTIONS.includes(value)) {
        updated.processingAgency = "";
        // setMessageMode(`Processing Agency has been cleared because you selected "${value}" as Mode.`);
      }

      // Condition 2: If processingAgency is being edited, but mode is in modeOptions → keep it empty
      if (id === "processingAgency" && MODE_OPTIONS.includes(prev.mode)) {
        updated.processingAgency = ""; // force it to stay empty
        //  setMessageMode(`Cannot select Processing Agency when Mode is "${prev.mode}".`);
        setMessageMode(
          `Cannot select Processing Agency when Mode is one of these: Manual, One Time Donation, CASH, UPI, Online, Cheque.`,
        );
      }

      return updated;
    });
  };

  // Optional: Auto-hide message after 3 seconds
  useEffect(() => {
    if (messageMode) {
      const timer = setTimeout(() => setMessageMode(""), 3000); // hide after 3 seconds
      return () => clearTimeout(timer);
    }
  }, [messageMode]);

  // console.log("Edit Mode", isEditMode);

  // Handle Submit (Add or Edit)
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      fullName: userDetailsFormData.fullName,
      schemePatronshipNo: userDetailsFormData.schemePatronshipNo,
      phoneNumber: userDetailsFormData.phoneNumber,
      address: userDetailsFormData.address,
      is_address_confirmed: userDetailsFormData.is_address_confirmed,
      mailingCity: userDetailsFormData.mailingCity,
      mailingCountry: userDetailsFormData.mailingCountry,
      mailingState: userDetailsFormData.mailingState,
      dateOfBirth: userDetailsFormData.dateOfBirth, //Not sure
      mailingZip: userDetailsFormData.mailingZip,
      occupation: userDetailsFormData.occupation,
      gender: userDetailsFormData.gender,
      whatsappNumber: userDetailsFormData.whatsappNumber,
      whatsappUpdate: userDetailsFormData.whatsappUpdate, // Not sure
      // bankAccountName: userDetailsFormData.bankAccountName,
      startDate: userDetailsFormData.startDate, // Not sure
      email: userDetailsFormData.email,
      frequency: userDetailsFormData.frequency,
      amount: userDetailsFormData.amount,
      donationType: userDetailsFormData.donationType, // Not sure
      mode: userDetailsFormData.mode, // Not sure
      patronshipLevel: userDetailsFormData.patronshipLevel,
      remarks: userDetailsFormData.remarks, // Not sure
      status: userDetailsFormData.status,
      statusDetails: userDetailsFormData.statusDetails,
      panNo: userDetailsFormData.panNo, // Not sure
      stopHoldDate: userDetailsFormData.stopHoldDate, // Not sure
      enrolledByContact: userDetailsFormData.enrolledByContact,
      depositoryBank: userDetailsFormData.depositoryBank, // Not sure
      whatsappGroupNo: userDetailsFormData.whatsappGroupNo, // Not sure
      want80G: userDetailsFormData.want80G,
      leadSource: userDetailsFormData.leadSource,
      enrolledByName: userDetailsFormData.enrolledByName,
      bankName: userDetailsFormData.bankName,
      preacherName: userDetailsFormData.preacherName,
      trNumber: userDetailsFormData.trNumber,
      totalDonation: userDetailsFormData.totalDonation,
      // bankAccountName: userDetailsFormData.accountHolderName,
      bankIFSC: userDetailsFormData.bankIFSC,
      bankBranch: userDetailsFormData.bankBranch,
      bankAccountNo: userDetailsFormData.bankAccountNo,
      processingAgency: userDetailsFormData.processingAgency,
      accountHolderName: userDetailsFormData.accountHolderName,
      manualType: userDetailsFormData.manualType,
      micrNo: userDetailsFormData.micrNo,
      deductionDay: userDetailsFormData.deductionDay,
      utilityCode: userDetailsFormData.utilityCode,
      isVolunteer: userDetailsFormData.isVolunteer,
    };

    // console.log("Donor Data", payload);

    // return;

    try {
      let response;
      if (isEditMode) {
        response = await axiosAPI.put(
          `/api/donor/update-user-by-id/${currentUserId}`,
          payload,
        );
        // response = await axios.put(
        //   `http://localhost:5000/api/students/update-student/${currentUserId}`,
        //   payload
        // );
        // window.location.reload();
        closeModal();
        hideModal("editModal");
        // fetchUsers();
        fetchDonors();
        window.notifyMessage(
          "Success",
          "Donor Details Updated successfully",
          "success",
        );
      } else {
        response = await axiosAPI.post(`/api/donor/add-donor`, payload);
        // response = await axios.post(
        //   "http://localhost:5000/api/students/add-student",
        //   payload
        // );
        // fetchUsers();
        window.notifyMessage("Success", "Donor successfully added", "success");
        closeModal();
        removeFormData();
        hideModal("editModal");
      }

      fetchDonors();

      // fetchUsers();

      // console.log("Emnpty form data");
      closeModal();

      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage(
          "Error",
          error.response.data.message, // Display specific error message from backend
          "danger",
        );
      } else {
        // Handle generic errors (e.g., network errors)
        window.notifyMessage("Error", "There was an error!", "danger");
      }
    }
  };

  const downloadPdf = () => {
    const input = receiptRef.current;

    // console.log("Input ", input);

    html2canvas(input, {
      scale: 2,
      useCORS: true, // Enable CORS to allow external images to be loaded
      allowTaint: true, // Allow tainting the canvas
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`DonationReceipt_${receiptDetails?.full_name || "User"}.pdf`);
    });

    setShowPdfModal(false);
    setReceiptDetails("");
  };

  const fetchReceiptDetails = async (id) => {
    setLoading(true); // Start loading

    try {
      const response = await axiosAPI.get(
        `/api/donor/download-patron-card/${id}`,
      );
      setReceiptDetails(response.data.user_details);
    } catch (error) {
      console.error("Error fetching receipt details:", error);
    } finally {
      setLoading(false); // Always stop loading
    }
  };

  const openReceiptModal = (id) => {
    // console.log("id ", id);
    const selecteRecurrer = users.find((donor) => donor.id === id);

    fetchReceiptDetails(id);
    setShowPdfModal(true);
    // console.log("Receipt", selecteRecurrer);
  };

  const downloadExcel = async (table_name) => {
    setDownloading(true); //  Start loader
    const queryString = buildQuery(filters, "1");

    // console.log("query ", queryString);

    // return

    try {
      const response = await axiosAPI.get(
        `/api/donor/download-donor-excel?table=${table_name}&${queryString}`, //  Pass table name in query
        {
          responseType: "blob",
        },
      );

      if (response.status !== 200) {
        throw new Error("Failed to download file");
      }

      const blob = response.data;
      const url = window.URL.createObjectURL(new Blob([blob]));

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${table_name}.xlsx`); // Optional: dynamic file name
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error("Download failed:", error);
      // alert("Failed to download file. Please try again later.");
      console.error("Download failed:", error);
      const message = error?.response?.statusText || "Unknown error";
      alert("Failed to download file: " + message);
    } finally {
      setDownloading(false); //  End loader
    }
  };

  const fetchUserDetails = async (id) => {
    setIsEditMode(true);
    try {
      const response = await axiosAPI.get(`/api/donor/get-user-by-id/${id}`);
      const data = response.data.data;

      setCurrentPhoneNumber(data?.phone_number);

      // console.log("User Details", data);
      // console.log(data);
      setUserDetails(data);

      // Yeh line form ke fields ko fill kar degi
      setUserDetailsFormData({
        fullName: data.user_full_name || "",
        // contact_id: data.contact_id || "",
        schemePatronshipNo: data.donor_id || "",
        phoneNumber: data.phone_number || "",
        address: data.address || "",
        is_address_confirmed: data.is_address_confirmed || "",
        mailingCity: data.city || "",
        mailingCountry: data.country || "",
        mailingState: data.state || "",
        dateOfBirth: data.date_of_birth || "", //Not sure
        mailingZip: data.zip_code || "",
        occupation: data.occupation || "",
        gender: data.gender || "",
        whatsappNumber: data.user_whatsapp_number || "",
        whatsappUpdate: data.whatsapp_update || "", // Not sure
        // bankAccountName: data.bank_account_name || "",
        phone: data.phone_number || "",
        startDate: data.start_date || "", // Not sure
        email: data.email || "",
        frequency: data.donation_frequency || "",
        amount: data.donation_amount || "",
        donationType: data.donation_type || "", // Not sure
        mode: data.mode || "", // Not sure
        whatsappGroupNo: data.whatsapp_group_no || "", // Not sure
        patronshipLevel: data.patronship_level || "",
        remarks: data.remarks || "", // Not sure
        status: data.status || "",
        // statusDetails: data.status_details || "",
        statusDetails: data.umrn_no || "",
        panNo: data.pan_no || "", // Not sure
        stopHoldDate: data.stop_date || "", // Not sure
        enrolledByContact: data.enrolled_devotee_phone_no || "",
        depositoryBank: data.depository_bank || "", // Not sure
        want80G: data.want_80g || "",
        leadSource: data.lead_source || "",
        enrolledByName: data.enrolled_devotee_name || "",
        bankName: data.bank_name || "",
        preacherName: data.preacher_name || "",
        trNumber: data.tr_number || "",
        totalDonation: data.total_donation || "",
        // bankAccountName: data.account_holder_name || "",
        bankIFSC: data.bank_ifsc || "",
        bankBranch: data.bank_branch || "",
        bankAccountNo: data.bank_account_no || "",
        processingAgency: data.processing_agency || "",
        accountHolderName: data.account_holder_name || "",
        manualType: data.manual_type || "",
        micrNo: data.micr,
        deductionDay: data.deduction_day,
        utilityCode: data.utility_code,
        isVolunteer: data.is_volunteer,
      });
    } catch (error) {
      console.error("Error fetching user details:", error);
      setLoading(false);
    }
  };

  function openOtpModal(id) {
    showModal("staticBackdrop");
    setCurrentUserId(id);
  }

  const handlePasswordChange = async () => {
    try {
      if (!newPassword) {
        alert("Please enter a new password");
        return;
      }

      const payload = {
        password: newPassword,
      };

      setOtpLoader(true);
      // Call API to update password
      await axiosAPI.put(
        `/api/donor/change-password/${currentUserId}`,
        payload,
      );

      alert("Password changed successfully!");
      setNewPassword("");
      // Optionally close modal
      window.notifyMessage(
        "Success",
        "Password changed successfully",
        "success",
      );
    } catch (err) {
      console.error(err);
      alert("Failed to change password.");
    } finally {
      setOtpLoader(false);
    }
  };

  // const openUserDetailsModal = (id) => {
  //   if (!id || !users || users.length === 0) return null;

  //   console.log("Id",id);

  //   const selectedDonor = users.find((donor) => donor.id === id);

  //   console.log("selected donor",selectedDonor)

  //   if (!selectedDonor) return false;

  //   setCurrentUserId(id);
  //   setCurrentPhoneNumber(selectedDonor.phone_number);
  //   fetchUserDetails(id);
  //   showModal("editModal");
  //   editModeOff();

  //   return true;
  // };

  //   const openUserDetailsModal = (id) => {
  //   setCurrentUserId(id);
  //   const selecteRecurrer = users.find((donor) => donor.id === id);
  //   // console.log("Seleted ",selecteRecurrer)
  //   setCurrentPhoneNumber(selecteRecurrer?.phone_number);
  //   fetchUserDetails(id);
  //   showModal("editModal");
  //   editModeOff();
  // };

  const openUserDetailsModal = (id) => {
    if (!id) return false;

    setCurrentUserId(id);
    editModeOff();
    showModal("editModal");

    fetchUserDetails(id);

    return true;
  };

  const editModeOn = () => {
    setIsEditable(true);
  };
  const editModeOff = () => {
    setIsEditable(false);
  };

  // Close Modal
  const closeModal = () => {
    setIsEditMode(false);
    removeFormData();
    setCurrentUserId(null);
    setUploadRows("");
    setActiveTab("User Details");
  };

  const openAddModal = () => {
    // Optionally, you can open the modal programmatically here if you're using Bootstrap modals
    removeFormData();
    showModal("editModal");
  };

  const openUploadDonorModal = () => {
    // console.log("Inside Modal");
    showModal("newGiftExcelModal");
  };

  const openExportDonorModal = () => {
    // console.log("Inside Modal");
    showModal("exportDonorExcelModal");
  };

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex flex-column flex-md-row justify-content-end align-items-stretch align-items-md-center mb-3 gap-2">
          {/* Right side: Buttons container */}
          <div className="d-flex flex-column flex-sm-row gap-2">
            {/* <button
              type="button"
              className="btn btn-success btn-round"
              // onClick={handleExportDonations}
              onClick={() => {
                if (
                  filters.search ||
                  filters.level ||
                  filters.agency ||
                  filters.payment_mode ||
                  filters.status
                ) {
                  // downloadExcel("donor"); // Pass filters if needed

                  openExportDonorModal();
                } else {
                  const confirmFullDownload = window.confirm(
                    "No filters applied. Do you want to download the full sheet?"
                  );
                  if (confirmFullDownload) {
                    downloadExcel("donor"); //  Full sheet export
                  }
                }
              }}
              disabled={downloading}
            >
              Export Donor
            </button> */}
            <button
              type="button"
              className="btn btn-success btn-round"
              // onClick={handleExportDonations}
              onClick={openExportDonorModal}
              disabled={downloading}
            >
              Export Donor
            </button>

            <button
              type="button"
              className="btn btn-success btn-round"
              onClick={() => openUploadDonorModal()}
            >
              Upload Donor
            </button>
            <button
              type="button"
              className="btn btn-success btn-round"
              onClick={() => handleBulkUpdateModal()}
            >
              Bulk Update
            </button>
            <button
              type="button"
              className="btn btn-dark btn-round"
              onClick={() => openAddModal()}
            >
              Add Donor
            </button>
          </div>
        </div>

        {/* Export Donor Details */}
        <div
          className="modal fade"
          id="exportDonorExcelModal"
          tabIndex="-1"
          aria-labelledby="exportDonorExcelModal"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exportDonorExcelModal">
                  Export Details
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    closeModal();
                    setView("excel");
                  }}
                ></button>
              </div>

              <div className="modal-body">
                <h6 className="mb-2">Select Fields to Export</h6>

                {/* Select All */}
                <div className="form-check mb-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="selectAll"
                    checked={selectedFields.length === fieldsList.length}
                    onChange={handleSelectAll}
                  />
                  <label
                    className="form-check-label fw-bold"
                    htmlFor="selectAll"
                  >
                    Select All
                  </label>
                </div>

                <hr />

                {/* Individual Checkboxes */}
                <div className="d-flex flex-row flex-wrap">
                  {fieldsList.map((field, index) => (
                    <div className="form-check d-flex " key={index}>
                      <input
                        className="form-check-input me-2"
                        type="checkbox"
                        id={`field-${index}`}
                        checked={selectedFields.includes(field)}
                        onChange={() => handleCheckboxChange(field)}
                      />

                      <label
                        className="form-check-label"
                        htmlFor={`field-${index}`}
                      >
                        {field?.split("_")?.join(" ")}
                      </label>
                    </div>
                  ))}
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    className="btn btn-danger btn-round"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-success btn-round"
                    // onClick={handleExportDonations}
                    onClick={() => {
                      if (
                        filters.search ||
                        filters.level ||
                        filters.agency ||
                        filters.payment_mode ||
                        filters.status
                      ) {
                        downloadExcel("donor"); // Pass filters if needed
                      } else {
                        const confirmFullDownload = window.confirm(
                          "No filters applied. Do you want to download the full sheet?",
                        );
                        if (confirmFullDownload) {
                          downloadExcel("donor"); //  Full sheet export
                        }
                      }
                    }}
                    disabled={downloading}
                  >
                    Export Donor
                  </button>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>

        {downloading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              className="spinner-border text-success"
              role="status"
              style={{ width: "3rem", height: "3rem" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}

        {/* PASSWORD CHANGE MODAL */}
        <div
          className="modal fade"
          id="staticBackdrop"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="staticBackdropLabel">
                    Change Password
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>

                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">New Password</label>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Enter new password"
                      value={newPassword ?? ""}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={otpLoader}
                    onClick={handlePasswordChange}
                  >
                    {otpLoader ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Changing...
                      </>
                    ) : (
                      "Change Password"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Pdf Modal */}
        {showPdfModal && (
          <div
            className="modal show d-block"
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-xl modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Receipt</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                      setShowPdfModal(false);
                      setReceiptDetails("");
                    }}
                  ></button>
                </div>

                {/*  Your Custom FOLK Content Goes Here */}
                <DonorCard ref={receiptRef} receiptDetails={receiptDetails} />

                <div className="modal-footer">
                  <button className="btn btn-success" onClick={downloadPdf}>
                    Download PDF
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowPdfModal(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* user details modal */}
        <div
          className="modal fade"
          id="editModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-fullscreen">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  {isEditMode ? "Edit Donor" : "Add Donor"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => closeModal()} // First function
                ></button>
              </div>

              <div className={`modal-body`}>
                {isEditMode && !isEditable && (
                  <div className="d-flex justify-content-between align-items-center mt-2 mb-3">
                    {/* Left Nav Tabs (horizontal look like tabs) */}

                    <ul className="nav nav-tabs">
                      <li className="nav-item">
                        <button
                          className={`nav-link ${
                            activeTab === "User Details" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("User Details")}
                        >
                          User Details
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className={`nav-link ${
                            activeTab === "gifts" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("gifts")}
                        >
                          Gifts
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className={`nav-link ${
                            activeTab === "donations" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("donations")}
                        >
                          Manual Donations
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className={`nav-link ${
                            activeTab === "Recurring donation" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("Recurring donation")}
                        >
                          Auto Recurring Donation
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className={`nav-link ${
                            activeTab === "Follow Up Remarks" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("Follow Up Remarks")}
                        >
                          Follow Up Remarks
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className={`nav-link ${
                            activeTab === "Other Account" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("Other Account")}
                        >
                          Other Account
                        </button>
                      </li>
                    </ul>
                    {/* Right Side Button */}
                    <div>
                      {activeTab === "User Details" && (
                        <button
                          type="button"
                          className="btn btn-dark btn-round ms-3"
                          onClick={() => editModeOn()}
                        >
                          Edit Donor
                        </button>
                      )}
                    </div>
                  </div>
                )}

                {activeTab === "gifts" ? (
                  <GiftTab donor_id={currentUserId} />
                ) : (
                  ""
                )}
                {activeTab === "donations" ? (
                  <DonationTab donor_id={currentUserId} />
                ) : (
                  ""
                )}
                {activeTab === "Recurring donation" ? (
                  <RecurringDonationTab donor_id={currentUserId} />
                ) : (
                  ""
                )}
                {activeTab === "Manual Recurring donations" ? (
                  <ManualRecurringDonationTab donor_id={currentUserId} />
                ) : (
                  ""
                )}
                {activeTab === "Follow Up Remarks" ? (
                  <FollowUpRemarkTab donor_id={currentUserId} />
                ) : (
                  ""
                )}
                {activeTab === "Other Account" ? (
                  <OtherAccount
                    donor_id={currentUserId}
                    current_phone_number={currentPhoneNumber}
                  />
                ) : (
                  ""
                )}

                {activeTab === "User Details" ? (
                  <form
                    onSubmit={handleSubmit}
                    className={`${
                      isEditMode && !isEditable
                        ? "not-editable-modal"
                        : "editable-modal"
                    }`}
                  >
                    {/* First Name */}
                    <div className="card border">
                      <div className="card-body">
                        {/* About the Event Section */}
                        <h5>
                          <b>Personal Details</b>
                        </h5>
                        <div className="row mt-3">
                          <div className="row">
                            {/* <div className="mb-3 col-md-6">
                              <label
                                htmlFor="contact_id"
                                className="form-label"
                              >
                                Contact ID
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="contact_id"
                                value={userDetailsFormData.contact_id}
                                onChange={handleUserDetailsChange}
                                disabled
                              />
                            </div> */}

                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="schemePatronshipNo"
                                className="form-label"
                              >
                                Donor ID
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="schemePatronshipNo"
                                required
                                value={userDetailsFormData.schemePatronshipNo}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            {/* Mandate Name */}
                            <div className="mb-3 col-md-6">
                              <label htmlFor="fullName" className="form-label">
                                Full Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="fullName"
                                value={userDetailsFormData.fullName}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            {/* Address */}
                            <div className="mb-3 col-md-6">
                              <label htmlFor="address" className="form-label">
                                Address
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="address"
                                value={userDetailsFormData.address}
                                onChange={handleUserDetailsChange}
                              />
                            </div>
                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="is_address_confirmed"
                                className="form-label"
                              >
                                Confirm Address
                              </label>
                              <select
                                className="form-select"
                                id="is_address_confirmed"
                                value={userDetailsFormData.is_address_confirmed}
                                onChange={handleUserDetailsChange}
                                name="is_address_confirmed" // Make sure this matches your state field name
                              >
                                <option value="">-- Select --</option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                              </select>
                            </div>

                            {/* Mailing City */}
                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="mailingCity"
                                className="form-label"
                              >
                                City
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="mailingCity"
                                value={userDetailsFormData.mailingCity}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            {/* Mailing State */}
                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="mailingState"
                                className="form-label"
                              >
                                State
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="mailingState"
                                value={userDetailsFormData.mailingState}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            {/* Mailing Country */}
                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="mailingCountry"
                                className="form-label"
                              >
                                Country
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="mailingCountry"
                                value={userDetailsFormData.mailingCountry}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="mailingZip"
                                className="form-label"
                              >
                                Pin Code
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="mailingZip"
                                value={userDetailsFormData.mailingZip}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="dateOfBirth"
                                className="form-label"
                              >
                                Date of Birth
                              </label>
                              <input
                                type="date"
                                className="form-control"
                                id="dateOfBirth"
                                value={userDetailsFormData.dateOfBirth}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label htmlFor="gender" className="form-label">
                                Gender
                              </label>
                              <select
                                className="form-select"
                                id="gender"
                                name="gender"
                                value={userDetailsFormData.gender}
                                onChange={handleUserDetailsChange}
                              >
                                <option value="">Select Gender</option>
                                <option value="M">Male</option>
                                <option value="F">Female</option>
                              </select>
                            </div>

                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="occupation"
                                className="form-label"
                              >
                                Occupation
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="occupation"
                                value={userDetailsFormData.occupation}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="phoneNumber"
                                className="form-label"
                              >
                                Phone
                              </label>
                              <input
                                type="text"
                                maxLength={10}
                                className="form-control"
                                id="phoneNumber"
                                value={userDetailsFormData.phoneNumber}
                                onChange={handleUserDetailsChange}
                                required
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="whatsappNumber"
                                className="form-label"
                              >
                                Whatsapp No.
                              </label>
                              <input
                                type="text"
                                maxLength={10}
                                className="form-control"
                                id="whatsappNumber"
                                value={userDetailsFormData.whatsappNumber}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label htmlFor="email" className="form-label">
                                Email
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                id="email"
                                value={userDetailsFormData.email}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="whatsappUpdate"
                                className="form-label"
                              >
                                Whatsapp Update
                              </label>
                              <select
                                className="form-select"
                                id="whatsappUpdate"
                                value={userDetailsFormData.whatsappUpdate}
                                onChange={handleUserDetailsChange}
                                name="whatsappUpdate"
                              >
                                <option value="">Select an option</option>
                                <option value="Y">Y</option>
                                <option value="N">N</option>
                              </select>
                            </div>

                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="whatsappGroupNo"
                                className="form-label"
                              >
                                Whatsapp Group No.
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="whatsappGroupNo"
                                value={userDetailsFormData.whatsappGroupNo}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label htmlFor="panNo" className="form-label">
                                PAN No.
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="panNo"
                                value={userDetailsFormData.panNo}
                                onChange={handleUserDetailsChange}
                              />
                            </div>
                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="isVolunteer"
                                className="form-label"
                              >
                                Volunteer
                              </label>
                              <select
                                className="form-select"
                                id="isVolunteer"
                                value={userDetailsFormData.isVolunteer}
                                onChange={handleUserDetailsChange}
                                name="isVolunteer"
                              >
                                <option value="" disabled>
                                  Select an option
                                </option>
                                <option value="yes">Y</option>
                                <option value="no">N</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card border">
                      <div className="card-body">
                        {/* About the Event Section */}
                        <h5>
                          <b>Donation Details</b>
                        </h5>
                        <div className="row mt-3">
                          <div className="row">
                            <div className="mb-3 col-md-6">
                              <label htmlFor="status" className="form-label">
                                Status
                              </label>
                              <select
                                className="form-select"
                                id="status"
                                name="status"
                                value={userDetailsFormData.status}
                                onChange={handleUserDetailsChange}
                              >
                                <option value="">Select Status</option>
                                <option value="active">Active</option>
                                <option value="closed">Closed</option>
                                <option value="inactive">Inactive</option>
                                <option value="on-hold">On-Hold</option>
                                <option value="submitted">Submitted</option>
                                <option value="accepted">Accepted</option>
                                <option value="rejected">rejected</option>
                                <option value="pending">Pending</option>
                                <option value="Deactivated">Deactivated</option>
                                <option value="NPCI rejected">
                                  NPCI Rejected
                                </option>
                                <option value=" TPSL rejected">
                                  {" "}
                                  TPSL Rejected
                                </option>
                              </select>
                            </div>

                            <div className="mb-3 col-md-6">
                              <label htmlFor="remarks" className="form-label">
                                Remarks
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="remarks"
                                value={userDetailsFormData.remarks}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label htmlFor="micrNo" className="form-label">
                                MICR No
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="micrNo"
                                value={userDetailsFormData.micrNo}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label htmlFor="startDate" className="form-label">
                                Start Date
                              </label>
                              <input
                                type="date"
                                className="form-control"
                                id="startDate"
                                value={userDetailsFormData.startDate}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label htmlFor="amount" className="form-label">
                                Amount
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="amount"
                                value={userDetailsFormData.amount}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="statusDetails"
                                className="form-label"
                              >
                                UMRN No
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="statusDetails"
                                value={userDetailsFormData.statusDetails}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label htmlFor="frequency" className="form-label">
                                Frequency
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="frequency"
                                value={userDetailsFormData.frequency}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label htmlFor="mode" className="form-label">
                                Mode
                              </label>
                              <select
                                className="form-select"
                                id="mode"
                                name="mode"
                                value={userDetailsFormData.mode}
                                onChange={handleUserDetailsChange}
                              >
                                <option value="">Select Mode</option>
                                <option value="NACH">NACH</option>
                                <option value="Manual">Manual</option>
                                <option value="One Time Donation">
                                  One Time Donation
                                </option>
                                <option value="SI">SI</option>
                                <option value="CASH">CASH</option>
                                <option value="UPI">UPI</option>
                                <option value="Online">Online</option>
                                <option value="Cheque">Cheque</option>
                              </select>
                              {/* Show the message dynamically */}
                              {/* {messageMode && (
                                  <div style={{ color: "red", marginTop: "5px" }}>
                                    {messageMode}
                                  </div>
                                )} */}
                            </div>

                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="processingAgency"
                                className="form-label"
                              >
                                Processing Agency
                              </label>
                              <select
                                className="form-select"
                                id="processingAgency"
                                name="processingAgency"
                                value={userDetailsFormData.processingAgency}
                                onChange={handleUserDetailsChange}
                              >
                                <option value="">
                                  Select Processing Agency
                                </option>
                                {/* <option value="YES BANK">YES BANK</option>
                                <option value="TECH PROCESS">
                                  TECH PROCESS
                                </option>
                                <option value="TP3489">TP3489</option>
                                <option value="RAZORPAY">RAZORPAY</option>
                                <option value="PHONE PAY">PHONE PAY</option>
                                <option value="SBI SI">SBI SI</option>
                                <option value="SBI ACH">SBI ACH</option>
                                <option value="EASE BUZZ">EASE BUZZ</option> */}
                                {!agenciesLoading &&
                                  agencies.map((agency) => (
                                    <option
                                      key={agency.name}
                                      value={agency.name}
                                    >
                                      {agency.name}
                                    </option>
                                  ))}
                              </select>
                              {/* Show the message dynamically */}
                              {messageMode && (
                                <div style={{ color: "red", marginTop: "5px" }}>
                                  {messageMode}
                                </div>
                              )}
                            </div>

                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="deductionDay"
                                className="form-label"
                              >
                                Deduction Day
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="deductionDay"
                                value={userDetailsFormData.deductionDay}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="bankAccountNo"
                                className="form-label"
                              >
                                Bank Account No
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="bankAccountNo"
                                value={userDetailsFormData.bankAccountNo}
                                onChange={handleUserDetailsChange}
                              />
                            </div>
                            <div className="mb-3 col-md-6">
                              <label htmlFor="bankName" className="form-label">
                                Bank Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="bankName"
                                value={userDetailsFormData.bankName}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="bankBranch"
                                className="form-label"
                              >
                                Bank Branch
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="bankBranch"
                                value={userDetailsFormData.bankBranch}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="accountHolderName"
                                className="form-label"
                              >
                                {/* Bank Account Name */}
                                Account Holder Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="accountHolderName"
                                value={userDetailsFormData.accountHolderName}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label htmlFor="bankIFSC" className="form-label">
                                Bank IFSC
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="bankIFSC"
                                value={userDetailsFormData.bankIFSC}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="totalDonation"
                                className="form-label"
                              >
                                Total Donation
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="totalDonation"
                                value={userDetailsFormData.totalDonation}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label htmlFor="trNumber" className="form-label">
                                TR Number
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="trNumber"
                                value={userDetailsFormData.trNumber}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="donationType"
                                className="form-label"
                              >
                                Donation Type
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="donationType"
                                value={userDetailsFormData.donationType}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="stopHoldDate"
                                className="form-label"
                              >
                                Stop/Hold Date
                              </label>
                              <input
                                type="date"
                                className="form-control"
                                id="stopHoldDate"
                                value={userDetailsFormData.stopHoldDate}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="depositoryBank"
                                className="form-label"
                              >
                                Depository Bank
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="depositoryBank"
                                value={userDetailsFormData.depositoryBank}
                                onChange={handleUserDetailsChange}
                              />
                            </div>
                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="manualType"
                                className="form-label"
                              >
                                Manual Type
                              </label>
                              <select
                                className="form-control"
                                id="manualType"
                                name="manualType"
                                value={userDetailsFormData.manualType}
                                onChange={handleUserDetailsChange}
                              >
                                <option value="">Select Manual Type</option>
                                <option value="cash">Cash</option>
                                <option value="cheque">Cheque</option>
                                <option value="online">Online</option>
                              </select>
                            </div>
                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="utilityCode"
                                className="form-label"
                              >
                                Utility Code
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="utilityCode"
                                value={userDetailsFormData.utilityCode}
                                onChange={handleUserDetailsChange}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-body shadow">
                        {/* About the Event Section */}
                        <h5>
                          <b>Other Donation Details</b>
                        </h5>
                        <div className="row mt-3">
                          <div className="row">
                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="patronshipLevel"
                                className="form-label"
                              >
                                Patronship Level
                              </label>
                              <select
                                className="form-select"
                                id="patronshipLevel"
                                name="patronshipLevel"
                                value={userDetailsFormData.patronshipLevel}
                                onChange={handleUserDetailsChange}
                              >
                                <option value="">
                                  Select Patronship Level
                                </option>
                                <option value="BRONZE">Bronze</option>
                                <option value="SILVER">Silver</option>
                                <option value="GOLD">Gold</option>
                                <option value="DIAMOND">Diamond</option>
                              </select>
                            </div>

                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="enrolledByContact"
                                className="form-label"
                              >
                                Enrolled By (Devotee Contact No.)
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="enrolledByContact"
                                value={userDetailsFormData.enrolledByContact}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label htmlFor="want80G" className="form-label">
                                Want 80G
                              </label>
                              <select
                                className="form-select"
                                id="want80G"
                                value={userDetailsFormData.want80G}
                                onChange={handleUserDetailsChange}
                              >
                                <option value="">- None -</option>
                                <option value="Y">Y</option>
                                <option value="N">N</option>
                              </select>
                            </div>
                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="leadSource"
                                className="form-label"
                              >
                                Lead Source
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="leadSource"
                                value={userDetailsFormData.leadSource}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="enrolledByName"
                                className="form-label"
                              >
                                Enrolled By (Devotee Name)
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="enrolledByName"
                                value={userDetailsFormData.enrolledByName}
                                onChange={handleUserDetailsChange}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label
                                htmlFor="preacherName"
                                className="form-label"
                              >
                                Preacher Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="preacherName"
                                value={userDetailsFormData.preacherName}
                                onChange={handleUserDetailsChange}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {isEditMode && isEditable && (
                      <button
                        type="submit"
                        className="btn btn-primary btn-round btn-sm"
                      >
                        Update Donor
                      </button>
                    )}

                    {!isEditMode && (
                      <button
                        type="submit"
                        className="btn btn-primary btn-round btn-sm"
                      >
                        Add Donor
                      </button>
                    )}
                  </form>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Add Donor Modal */}
        <div
          className="modal fade"
          id="newUserModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div
            className={`modal-dialog ${
              view === "manual"
                ? "modal-fullscreen"
                : "modal-dialog-centered modal-dialog-scrollable modal-md"
            }`}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  {isEditMode ? "Edit Donor" : "Add Donor"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    closeModal();
                    setView("excel");
                  }}
                ></button>
              </div>

              <div className="modal-body">
                {view === "excel" && (
                  <>
                    {/* Excel Upload UI */}
                    <div className="mb-3">
                      <label htmlFor="excelUpload" className="form-label">
                        Upload Excel File (.xlsx)
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        id="excelUpload"
                        accept=".xlsx"
                        ref={fileInputRef}
                        onChange={handleExcelFileChange}
                      />

                      <button
                        className="btn btn-success mt-3"
                        onClick={handleExcelSubmit} // Submit to backend
                      >
                        Upload
                      </button>
                      {message && <div className="mt-2">{message}</div>}
                      {/* Display any messages */}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Update Donor in Bulk */}
        <div
          className="modal fade"
          id="newBulkModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div
            className={`modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md`}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  {isEditMode ? "Edit Status" : "Update Status Change"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    closeModal();
                    setBulkView("bulk");
                  }}
                ></button>
              </div>

              <div className="modal-body">
                {bulkView === "bulk" && (
                  <>
                    {/* Excel Upload UI */}
                    <div className="mb-3">
                      <label htmlFor="excelUpload" className="form-label">
                        Upload Excel File (.xlsx)
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        id="excelUpload"
                        accept=".xlsx"
                        ref={bulkFileInputRef}
                        onChange={handleBulkExcelFileChange}
                      />
                      <div className="mt-3">
                        <button
                          type="button"
                          className="btn btn-link p-0 text-primary"
                          onClick={() => {
                            const link = document.createElement("a");
                            link.href =
                              "/samples/Bulk Update Patron Sample.xlsx";
                            link.download = "Bulk Update Patron Sample.xlsx";
                            link.click();
                          }}
                        >
                          Download Sample Sheet
                        </button>
                      </div>
                      <br />
                      Excel columns must be in the exact spelling:
                      <small className=" text-sm d-block">
                        <div className="mt-2 d-flex flex-wrap">
                          <span className="badge rounded-pill bg-light mb-2 text-dark me-1">
                            donor_id
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            full_name
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            phone_number
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            whatsapp_number
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            email
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            date_of_birth
                          </span>
                          <span className="badge rounded-pill bg-light mb-2 text-dark me-1">
                            donation_amount
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            status
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            patronship_level
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            processing_agency
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            umrn_no
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            address
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            city
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            state
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            country
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            zip_code
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            gender
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            occupation
                          </span>
                          <span className="badge rounded-pill bg-light mb-2 text-dark me-1">
                            want_80g
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            micr
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            start_date
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            remarks
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            donation_frequency
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            mode
                          </span>
                          <span className="badge rounded-pill bg-light mb-2 text-dark me-1">
                            bank_account_no
                          </span>
                          <span className="badge rounded-pill bg-light text-dark me-1">
                            utility_code
                          </span>
                        </div>
                      </small>
                      <div
                        class="alert alert-warning"
                        className="mt-2"
                        role="alert"
                      >
                        <strong>Note:</strong> Status must be one of the
                        following:
                        <ul class="mt-2 mb-0 d-flex justify-content-center flex-wrap">
                          <li>
                            <span class="badge bg-secondary">submitted</span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">accepted</span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">rejected</span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">on-hold</span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">active</span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">inactive</span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">closed</span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">pending</span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">deactivated</span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">
                              NPCI rejected
                            </span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">
                              TPSL rejected
                            </span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">
                              NPCI acknowledged
                            </span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">success</span>
                          </li>
                        </ul>
                      </div>
                      <div
                        class="alert alert-warning"
                        className="mt-2"
                        role="alert"
                      >
                        <strong>Note:</strong> is address confirmed must be one
                        of the following:
                        <ul class="mt-2 mb-0 d-flex justify-content-center flex-wrap">
                          <li>
                            <span class="badge bg-secondary">yes</span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">no</span>
                          </li>
                        </ul>
                      </div>
                      <br />
                      {/* <div className="mt-3">
                        <button
                          type="button"
                          className="btn btn-link p-0 text-primary"
                          onClick={() => {
                            const link = document.createElement("a");
                            link.href = "/samples/MIS Sample Sheet.xlsx";
                            link.download = "MIS Sample Sheet.xlsx";
                            link.click();
                          }}
                        >
                          Download MIS Sample Sheet
                        </button>
                      </div> */}
                      <button
                        className="btn btn-success mt-3"
                        onClick={handleBulkExcelSubmit} // Submit to backend
                      >
                        Upload
                      </button>
                      {message && <div className="mt-2">{message}</div>}
                      {/* Display any messages */}
                      {uploadRows.length > 0 && (
                        <div className="mt-3">
                          <h5>Upload Summary:</h5>
                          <table className="table table-bordered table-striped">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Row</th>
                                <th>Status</th>
                                <th>Reason</th>
                              </tr>
                            </thead>
                            <tbody>
                              {uploadRows.map((rowData, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{rowData?.row}</td>
                                  <td
                                    style={{
                                      color:
                                        rowData?.status === "fail"
                                          ? "red"
                                          : "green",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {rowData?.status}
                                  </td>
                                  <td>{rowData?.reason || "-"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Add Donor Modal */}
        <div
          className="modal fade"
          id="newGiftExcelModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div
            className={`modal-dialog ${
              view === "manual"
                ? "modal-fullscreen"
                : "modal-dialog-centered modal-md"
            }`}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  {isEditMode ? "Edit Donor" : "Add Donor"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    closeModal();
                    setView("excel");
                  }}
                ></button>
              </div>

              <div className="modal-body">
                {view === "excel" && (
                  <>
                    {/* Excel Upload UI */}
                    <div className="mb-3">
                      <label htmlFor="excelUpload" className="form-label">
                        Upload Excel File (.xlsx)
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        id="excelUpload"
                        accept=".xlsx"
                        ref={fileInputRef}
                        onChange={handleExcelFileChange}
                      />
                      <div className="mt-3">
                        <button
                          type="button"
                          className="btn btn-link p-0 text-primary"
                          onClick={() => {
                            const link = document.createElement("a");
                            link.href = "/samples/donor_sample.xlsx";
                            link.download = "donor_sample.xlsx";
                            link.click();
                          }}
                        >
                          Download Sample Sheet
                        </button>
                      </div>

                      <div
                        class="alert alert-warning"
                        className="mt-2"
                        role="alert"
                      >
                        <strong>Note:</strong> Status must be one of the
                        following:
                        <ul class="mt-2 mb-0 d-flex justify-content-center flex-wrap">
                          <li>
                            <span class="badge bg-secondary">submitted</span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">accepted</span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">rejected</span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">on-hold</span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">active</span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">inactive</span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">closed</span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">pending</span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">deactivated</span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">
                              NPCI rejected
                            </span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">
                              TPSL rejected
                            </span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">
                              NPCI acknowledged
                            </span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">success</span>
                          </li>
                        </ul>
                      </div>

                      <div
                        class="alert alert-warning"
                        className="mt-2"
                        role="alert"
                      >
                        <strong>Note:</strong> is address confirmed must be one
                        of the following:
                        <ul class="mt-2 mb-0 d-flex justify-content-center flex-wrap">
                          <li>
                            <span class="badge bg-secondary">yes</span>
                          </li>
                          <li>
                            <span class="badge bg-secondary">no</span>
                          </li>
                        </ul>
                      </div>

                      <button
                        className="btn btn-success mt-3"
                        onClick={handleExcelSubmit} // Submit to backend
                      >
                        Upload
                      </button>
                      {message && <div className="mt-2">{message}</div>}
                      {/* Display any messages */}

                      {uploadRows.length > 0 && (
                        <div className="mt-3">
                          <h5>Upload Summary:</h5>
                          <table className="table table-bordered table-striped">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Row</th>
                                <th>Status</th>
                                <th>Reason</th>
                              </tr>
                            </thead>
                            <tbody>
                              {uploadRows.map((rowData, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{rowData?.row}</td>
                                  <td
                                    style={{
                                      color:
                                        rowData?.status === "fail"
                                          ? "red"
                                          : "green",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {rowData?.status}
                                  </td>
                                  <td>{rowData?.reason || "-"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Student Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                {/* Left side */}
                <h4 className="card-title mb-0">All Donors ({users.length})</h4>

                {/* Right side: Search + Dropdown */}
                <div className="d-flex flex-wrap align-items-center gap-3">
                  {/* Search input with button */}
                  <div
                    className="position-relative"
                    style={{
                      flexGrow: 1,
                      minWidth: "280px",
                      marginTop: "20px",
                    }}
                  >
                    <input
                      className="form-control shadow-sm px-3 py-2 border-2 w-100"
                      type="text"
                      placeholder="Enter name, phone number, or donor id"
                      value={filters.search}
                      aria-label="Search"
                      onChange={(e) =>
                        handleFilterChange("search", e.target.value)
                      }
                      style={{ paddingRight: "110px" }}
                    />
                  </div>

                  {/* Dropdown */}
                  {/* <div
                    className="d-flex flex-column"
                    style={{ minWidth: "180px" }}
                  >
                    <label className="form-label mb-1">Patronship Level</label>
                    <select
                      className="form-select"
                      value={filters.level}
                      onChange={(e) =>
                        handleFilterChange("level", e.target.value)
                      }
                      style={{ width: "100%" }}
                    >
                      <option value="">All Status</option>
                      <option value="BRONZE">BRONZE</option>
                      <option value="SILVER">SILVER</option>
                      <option value="GOLD">GOLD</option>
                      <option value="DIAMOND">DIAMOND</option>
                    </select>
                  </div> */}

                  <div
                    className="d-flex flex-column"
                    style={{ minWidth: "180px" }}
                  >
                    <label className="form-label mb-1">Patronship Level</label>
                    <Select
                      isMulti
                      placeholder="All Levels"
                      options={[
                        { value: "BRONZE", label: "BRONZE" },
                        { value: "SILVER", label: "SILVER" },
                        { value: "GOLD", label: "GOLD" },
                        { value: "DIAMOND", label: "DIAMOND" },
                      ]}
                      value={
                        filters?.level?.map((val) => ({
                          value: val,
                          label: val,
                        })) || []
                      } // ensure correct format
                      onChange={(selectedOptions) => {
                        handleFilterChange(
                          "level",
                          selectedOptions
                            ? selectedOptions.map((opt) => opt.value)
                            : [],
                        );
                      }}
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          width: "100%",
                        }),
                      }}
                    />
                  </div>

                  {/* Dropdown */}
                  <div
                    className="d-flex flex-column"
                    style={{ minWidth: "180px" }}
                  >
                    <label className="form-label mb-1">Processing Agency</label>
                    <select
                      className="form-select"
                      value={filters.agency}
                      onChange={(e) =>
                        handleFilterChange("agency", e.target.value)
                      }
                      style={{ width: "100%" }}
                    >
                      <option value="">All Agency</option>
                      {/* <option value="YES BANK">YES BANK</option>
                      <option value="TECH PROCESS">TECH PROCESS</option>
                      <option value="TP3489">TP3489</option>
                      <option value="RAZORPAY">RAZORPAY</option>
                      <option value="PHONE PAY">PHONE PAY</option>
                      <option value="SBI SI">SBI SI</option>
                      <option value="SBI ACH">SBI ACH</option>
                      <option value="EASE BUZZ">EASE BUZZ</option> */}
                      {!agenciesLoading &&
                        agencies.map((agency) => (
                          <option key={agency.id} value={agency.name}>
                            {agency.name}
                          </option>
                        ))}
                    </select>
                  </div>

                  {/* Dropdown */}
                  <div
                    className="d-flex flex-column"
                    style={{ minWidth: "180px" }}
                  >
                    <label className="form-label mb-1">Status</label>
                    <select
                      className="form-select"
                      value={filters.status}
                      onChange={(e) =>
                        handleFilterChange("status", e.target.value)
                      }
                      style={{ width: "100%" }}
                    >
                      <option value="">All Status</option>
                      <option value="active">Active</option>
                      <option value="closed">Closed</option>
                      <option value="inactive">Inactive</option>
                      <option value="on-hold">On Hold</option>
                    </select>
                  </div>

                  {/* Dropdown */}
                  <div
                    className="d-flex flex-column"
                    style={{ minWidth: "180px" }}
                  >
                    <label className="form-label mb-1">Mode</label>
                    <select
                      className="form-select"
                      value={filters.payment_mode}
                      onChange={(e) =>
                        handleFilterChange("payment_mode", e.target.value)
                      }
                      style={{ width: "100%" }}
                    >
                      <option value="">All Modes</option>
                      <option value="CASH">Cash</option>
                      <option value="Cheque">Cheque</option>
                      <option value="Online">Online</option>
                      <option value="NACH">NACH</option>
                      <option value="Manual">Manual</option>
                      <option value="One Time Donation">
                        One Time Donation
                      </option>
                      <option value="SI">SI</option>

                      <option value="UPI">UPI</option>
                    </select>
                  </div>

                  <div>
                    <button
                      className="btn btn-primary rounded-pill px-4"
                      onClick={handleSearchClick}
                      style={{
                        marginTop: "20px",
                      }}
                    >
                      Search
                    </button>
                  </div>

                  <div
                    className="d-flex flex-column"
                    style={{
                      marginTop: "20px",
                    }}
                  >
                    <button
                      className="btn btn-icon btn-round btn-dark py-3 px-3  me-2"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Reset Filters"
                      onClick={handleResetFilters}
                    >
                      <i className="fas fa-sync-alt"></i>
                    </button>
                  </div>
                </div>
              </div>

              {downloading && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                    zIndex: 9999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    className="spinner-border text-success"
                    role="status"
                    style={{ width: "3rem", height: "3rem" }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Agency</th>
                        <th>Mode</th>
                        <th>Phone Number</th>
                        <th>Whatsapp Number</th>
                        <th>Status</th>
                        {/* <th>Created At</th> */}
                        <th>Scheme Patronship No</th>
                        <th>Patronship Level</th>
                        {/* <th>Action</th> */}
                        {role === "admin" && (
                          <th>Action</th> // Show this if the role is "admin"
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="9" className="text-center">
                            {/* Loading... */}
                            <div
                              style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 9999,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                className="spinner-border text-success"
                                role="status"
                                style={{ width: "3rem", height: "3rem" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : notFoundMessage ? (
                        <tr>
                          <td colSpan="9" className="text-center text-danger">
                            {notFoundMessage}
                          </td>
                        </tr>
                      ) : users.length === 0 ? (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      ) : (
                        users.map((donor) => {
                          const formattedDate = new Date(
                            donor.created_at,
                          ).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          });

                          return (
                            <tr key={donor.id}>
                              <td>
                                {donor.first_name && donor.last_name
                                  ? `${donor.first_name} ${donor.last_name}`
                                  : donor.full_name
                                    ? donor.full_name
                                    : "No name assigned"}
                              </td>
                              <td>{donor.processing_agency}</td>
                              <td>{donor?.mode}</td>
                              <td>{donor.phone_number}</td>
                              <td>{donor.whatsapp_number || "null"}</td>
                              <td>{donor?.status}</td>
                              <td>{donor.donor_id}</td>
                              <td>{donor.patronship_level}</td>
                              <td>
                                {/* WhatsApp */}
                                <a
                                  href={`https://wa.me/${donor?.phone_number}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn btn-success btn-round btn-icon btn-sm me-2"
                                  title="WhatsApp"
                                >
                                  <i className="fab fa-whatsapp"></i>
                                </a>
                                {/* Phone Call */}
                                <a
                                  href={`tel:${donor?.phone_number}`}
                                  className="btn btn-dark btn-round btn-icon btn-sm me-2"
                                  title="Call"
                                >
                                  <i className="fas fa-phone"></i>
                                </a>

                                <button
                                  className="btn btn-dark btn-round btn-icon btn-sm me-2"
                                  onClick={() => openReceiptModal(donor.id)}
                                >
                                  <i className="fas fa-download"></i>
                                </button>

                                <button
                                  className="btn btn-dark btn-round btn-icon btn-sm me-2"
                                  onClick={() => {
                                    openUserDetailsModal(donor.id);
                                  }}
                                >
                                  <i className="fas fa-eye"></i>
                                </button>
                                <button
                                  className="btn btn-dark btn-round btn-icon btn-sm me-2"
                                  onClick={() => {
                                    openOtpModal(donor.id);
                                  }}
                                >
                                  <i className="fas fa-lock"></i>
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <nav aria-label="Page navigation">
              <ul className="pagination flex justify-content-end">
                {/* First Page */}
                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(1)}
                  >
                    First
                  </button>
                </li>

                {/* Previous */}
                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(page - 1)}
                  >
                    Previous
                  </button>
                </li>

                {/* Page Number Buttons in chunks */}
                {(() => {
                  const pageNumbers = [];
                  const maxPagesToShow = 5;
                  const startPage =
                    Math.floor((page - 1) / maxPagesToShow) * maxPagesToShow +
                    1;
                  const endPage = Math.min(
                    startPage + maxPagesToShow - 1,
                    totalPages,
                  );

                  for (let i = startPage; i <= endPage; i++) {
                    pageNumbers.push(
                      <li
                        key={i}
                        className={`page-item ${page === i ? "active" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageClick(i)}
                        >
                          {i}
                        </button>
                      </li>,
                    );
                  }
                  return pageNumbers;
                })()}

                {/* Next */}
                <li
                  className={`page-item ${
                    page === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(page + 1)}
                  >
                    Next
                  </button>
                </li>

                {/* Last Page */}
                <li
                  className={`page-item ${
                    page === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(totalPages)}
                  >
                    Last
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Donor;
